import { AcademyCourse } from '../../models/academy-course.model';

export const lessonspaceCourse: AcademyCourse = {
  slug: 'lessonspace-tips',
  trainingModuleId: 'lessonspace',
  titleKey: 'texts.Tutor_Academy_Course_Lessonspace_Title',
  descriptionKey: 'texts.Tutor_Academy_Course_Lessonspace_Description',
  isMandatory: false,
  hasSearchBoost: true,
  lessons: [
    {
      id: 'probeer-het-zelf',
      titleKey: 'texts.Tutor_Academy_Lessonspace_L1_Title',
      subtitleKey: 'texts.Tutor_Academy_Lessonspace_L1_Subtitle',
      type: 'text',
      actionUrlKey: 'texts.Tutor_Academy_Lessonspace_L1_Action_Url',
      actionLabelKey: 'texts.Tutor_Academy_Lessonspace_L1_Action',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L1_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L1_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L1_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L1_Paragraph4' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L1_Paragraph5' }
      ]
    },
    {
      id: 'werken-op-het-bord',
      titleKey: 'texts.Tutor_Academy_Lessonspace_L2_Title',
      subtitleKey: 'texts.Tutor_Academy_Lessonspace_L2_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L2_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L2_Paragraph2' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_Lessonspace_L2_Item1',
            'texts.Tutor_Academy_Lessonspace_L2_Item2',
            'texts.Tutor_Academy_Lessonspace_L2_Item3',
            'texts.Tutor_Academy_Lessonspace_L2_Item4'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L2_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L2_Paragraph4' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L2_Paragraph5' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L2_Paragraph6' }
      ]
    },
    {
      id: 'beeld-en-geluid',
      titleKey: 'texts.Tutor_Academy_Lessonspace_L3_Title',
      subtitleKey: 'texts.Tutor_Academy_Lessonspace_L3_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L3_Paragraph1' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_Lessonspace_L3_Item1',
            'texts.Tutor_Academy_Lessonspace_L3_Item2',
            'texts.Tutor_Academy_Lessonspace_L3_Item3',
            'texts.Tutor_Academy_Lessonspace_L3_Item4'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L3_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L3_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L3_Paragraph4' }
      ]
    },
    {
      id: 'als-er-iets-niet-werkt',
      titleKey: 'texts.Tutor_Academy_Lessonspace_L4_Title',
      subtitleKey: 'texts.Tutor_Academy_Lessonspace_L4_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L4_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L4_Paragraph2' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_Lessonspace_L4_Item1',
            'texts.Tutor_Academy_Lessonspace_L4_Item2',
            'texts.Tutor_Academy_Lessonspace_L4_Item3',
            'texts.Tutor_Academy_Lessonspace_L4_Item4'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L4_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L4_Paragraph4' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L4_Paragraph5' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L4_Paragraph6' }
      ]
    },
    {
      id: 'meer-leren',
      titleKey: 'texts.Tutor_Academy_Lessonspace_L5_Title',
      subtitleKey: 'texts.Tutor_Academy_Lessonspace_L5_Subtitle',
      headingKey: 'texts.Tutor_Academy_Lessonspace_L5_Heading',
      type: 'text',
      actionUrlKey: 'texts.Tutor_Academy_Lessonspace_L5_Action_Url',
      actionLabelKey: 'texts.Tutor_Academy_Lessonspace_L5_Action',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L5_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L5_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Lessonspace_L5_Paragraph3' }
      ]
    }
  ],
  quiz: [
    {
      id: 'telefoon',
      questionKey: 'texts.Tutor_Academy_Lessonspace_Q1_Question',
      isMultiSelect: false,
      answers: [
        { id: 'zonder-video', textKey: 'texts.Tutor_Academy_Lessonspace_Q1_Answer1' },
        { id: 'laptop', textKey: 'texts.Tutor_Academy_Lessonspace_Q1_Answer2' },
        { id: 'camera-aan', textKey: 'texts.Tutor_Academy_Lessonspace_Q1_Answer3' },
        { id: 'scherm-delen', textKey: 'texts.Tutor_Academy_Lessonspace_Q1_Answer4' }
      ],
      correctAnswerIds: ['laptop'],
      explanationKey: 'texts.Tutor_Academy_Lessonspace_Q1_Explanation'
    },
    {
      id: 'materiaal',
      questionKey: 'texts.Tutor_Academy_Lessonspace_Q2_Question',
      isMultiSelect: false,
      answers: [
        { id: 'voor-de-les', textKey: 'texts.Tutor_Academy_Lessonspace_Q2_Answer1' },
        { id: 'tijdens-de-les', textKey: 'texts.Tutor_Academy_Lessonspace_Q2_Answer2' },
        { id: 'voorlezen', textKey: 'texts.Tutor_Academy_Lessonspace_Q2_Answer3' },
        { id: 'na-afloop', textKey: 'texts.Tutor_Academy_Lessonspace_Q2_Answer4' }
      ],
      correctAnswerIds: ['voor-de-les'],
      explanationKey: 'texts.Tutor_Academy_Lessonspace_Q2_Explanation'
    },
    {
      id: 'leerling-doet-niets',
      questionKey: 'texts.Tutor_Academy_Lessonspace_Q3_Question',
      isMultiSelect: false,
      answers: [
        { id: 'geen-zin', textKey: 'texts.Tutor_Academy_Lessonspace_Q3_Answer1' },
        { id: 'weet-het-niet', textKey: 'texts.Tutor_Academy_Lessonspace_Q3_Answer2' },
        { id: 'muis', textKey: 'texts.Tutor_Academy_Lessonspace_Q3_Answer3' },
        { id: 'bord-niet-zien', textKey: 'texts.Tutor_Academy_Lessonspace_Q3_Answer4' }
      ],
      correctAnswerIds: ['weet-het-niet'],
      explanationKey: 'texts.Tutor_Academy_Lessonspace_Q3_Explanation'
    },
    {
      id: 'uitroepteken',
      questionKey: 'texts.Tutor_Academy_Lessonspace_Q4_Question',
      isMultiSelect: false,
      answers: [
        { id: 'verbinding', textKey: 'texts.Tutor_Academy_Lessonspace_Q4_Answer1' },
        { id: 'leerling-praat', textKey: 'texts.Tutor_Academy_Lessonspace_Q4_Answer2' },
        { id: 'camera-of-microfoon', textKey: 'texts.Tutor_Academy_Lessonspace_Q4_Answer3' }
      ],
      correctAnswerIds: ['camera-of-microfoon'],
      explanationKey: 'texts.Tutor_Academy_Lessonspace_Q4_Explanation'
    },
    {
      id: 'wat-je-zegt',
      questionKey: 'texts.Tutor_Academy_Lessonspace_Q5_Question',
      isMultiSelect: false,
      answers: [
        { id: 'eerst-oplossen', textKey: 'texts.Tutor_Academy_Lessonspace_Q5_Answer1' },
        { id: 'benoemen', textKey: 'texts.Tutor_Academy_Lessonspace_Q5_Answer2' },
        { id: 'camera-uit', textKey: 'texts.Tutor_Academy_Lessonspace_Q5_Answer3' },
        { id: 'opnieuw-inkomen', textKey: 'texts.Tutor_Academy_Lessonspace_Q5_Answer4' }
      ],
      correctAnswerIds: ['benoemen'],
      explanationKey: 'texts.Tutor_Academy_Lessonspace_Q5_Explanation'
    }
  ]
};
